import Immutable from 'immutable';
import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setAll = (state, { toolCycleTimeData }) => {
  if (!toolCycleTimeData) return state;
  return state.merge({ toolCycleTimeData });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};
//Tool cycle time Data Export set
const setToolCycleTimeExportData = (state, { toolCycleTimeExportData }) => {
  if (!toolCycleTimeExportData) return state;
  return state.merge({ toolCycleTimeExportData });
};
// Tool cycle time Data Export Loader
const setToolCycleTimeExportLoader = (state, { toolCycleTimeExportByLoader }) => {
  return state.merge({ toolCycleTimeExportByLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_ALL,
    actionFunction: setAll,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_TOOL_CYCLE_TIME_EXPORT_LOADER,
    actionFunction: setToolCycleTimeExportLoader,
  },
  {
    actionType: ActionTypes.SET_TOOL_CYCLE_TIME_EXPORT,
    actionFunction: setToolCycleTimeExportData,
  },
];
